// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import styles from './index.module.scss';
import { mergeClasses, normalizeNumber } from 'util/commons';
import { InfoBlock } from 'components/molecules/MyPage/InfoBlock';
import { Field } from 'components/molecules/MyPage/Field';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { MyPageType } from 'types/mypage';
import { useMypageContactInfo } from 'util/hooks/useMypageContactInfo';
import { REGEX_OBJECT } from 'util/ConstantValues';

export const EmissionAdminOperator = () => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const hasValidUser = !!user.userId && !!user.role;

  const myPage = useMypageContactInfo<MyPageType.EmissionAdminOperator>({
    myPageType: MyPageType.EmissionAdminOperator,
    enabled: hasValidUser,
  });

  return (
    <div className={styles.mypage}>
      <div className={styles.generalInfo}>
        <InfoBlock
          className={styles.accountInfo}
          title={t('my_page.account_info.title')}
        >
          <div className={styles.col}>
            <Field
              label={t('my_page.account_info.account_category')}
              value={t('my_page.emission_admin_operator.emission')}
            />
            <Field
              label={t('my_page.account_info.account_permissions')}
              value={t('my_page.account_info.admin_operator')}
            />
          </div>
        </InfoBlock>
        <InfoBlock
          className={styles.masterInfo}
          title={t('my_page.emission_admin_operator.master_info.title')}
        >
          <div className={styles.grid}>
            <Field
              label={t(
                'my_page.emission_admin_operator.master_info.company_name'
              )}
              value={myPage.data?.operatorName ?? ''}
            />
            <div className={styles.spanTwo}>
              <Field
                label={t(
                  'my_page.emission_admin_operator.master_info.headquarter_location'
                )}
                value={myPage.data?.address ?? ''}
              />
            </div>
            <Field
              label={t(
                'my_page.emission_admin_operator.master_info.number_of_managed_site'
              )}
              value={
                myPage.data?.siteCount != null
                  ? t(
                      'my_page.emission_admin_operator.master_info.site_count',
                      {
                        siteCount: normalizeNumber({
                          value: myPage.data.siteCount,
                        }),
                        manySite: myPage.data.siteCount === 1 ? '' : 's',
                      }
                    )
                  : ''
              }
            />
            <Field
              label={t(
                'my_page.emission_admin_operator.master_info.contact_person_name'
              )}
              value={myPage.data?.staffName ?? ''}
              maxLength={100}
              format="notSpecialCharacter"
              onEdit={(value) =>
                myPage.handleChangeInfo({
                  staffName: value,
                  tel: myPage.data?.tel,
                })
              }
            />
            <Field
              label={t(
                'my_page.emission_admin_operator.master_info.phone_number'
              )}
              value={myPage.data?.tel ?? ''}
              format="phone"
              regex={REGEX_OBJECT.number}
              maxLength={15}
              onEdit={(value) =>
                myPage.handleChangeInfo({
                  staffName: myPage.data?.staffName,
                  tel: value,
                })
              }
            />
          </div>
        </InfoBlock>
      </div>
      <div className={styles.additionalInfo}>
        <InfoBlock title={t('my_page.emission_admin_operator.list.title')}>
          <div className={styles.tableWrapper}>
            <table
              className={styles.table}
              style={{
                minWidth: 1000,
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: '50%' }}>
                    {t('my_page.emission_admin_operator.list.item_name')}
                  </th>
                  <th>
                    {t(
                      'my_page.emission_admin_operator.list.main_processing_method'
                    )}
                  </th>
                  <th className={styles.right}>
                    {t(
                      'my_page.emission_admin_operator.list.average_unit_price'
                    )}
                  </th>
                  <th className={styles.center}>
                    {t(
                      'my_page.emission_admin_operator.list.average_co2_emission_factor'
                    )}
                  </th>
                </tr>
              </thead>

              <tbody>
                {myPage.data?.items?.length ? (
                  myPage.data.items.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td
                          className={mergeClasses(
                            styles.light,
                            styles.bold,
                            styles.large
                          )}
                        >
                          <p>{item.name}</p>
                        </td>
                        <td>
                          <p>{item.recycleMethodName}</p>
                        </td>
                        <td
                          className={mergeClasses(styles.right, styles.light)}
                        >
                          <p>
                            {item.price != null && item.price !== ''
                              ? t(
                                  'my_page.emission_admin_operator.list.price_with_unit',
                                  {
                                    price: normalizeNumber({
                                      value: item.price,
                                      toFixed: 0,
                                    }),
                                  }
                                )
                              : ''}
                          </p>
                        </td>

                        <td className={styles.center}>
                          <p>
                            {normalizeNumber({
                              value: item.co2Factor,
                              toFixed: 3,
                            })}
                          </p>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={4} className={styles.noData}>
                      {t('messages.M_008')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </InfoBlock>
      </div>
    </div>
  );
};
